import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Consumption from '../entities/consumption'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface ConsumptionState extends ListState<Consumption> {
    editConsumption: Consumption;
}
class ConsumptionModule extends ListModule<ConsumptionState, any, Consumption>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Consumption>(),
        loading: false,
        editConsumption: new Consumption()
    }
    actions = {
        async getAll(context: ActionContext<ConsumptionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Consumption/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Consumption>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<ConsumptionState, any>, payload: any) {
            await Ajax.post('/api/services/app/Consumption/Create', payload.data);
        },
        async update(context: ActionContext<ConsumptionState, any>, payload: any) {
            await Ajax.put('/api/services/app/Consumption/Update', payload.data);
        },
        async delete(context: ActionContext<ConsumptionState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Consumption/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<ConsumptionState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Consumption/Get?Id=' + payload.id);
            return reponse.data.result as Consumption;
        }
    };
    mutations = {
        setCurrentPage(state: ConsumptionState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ConsumptionState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: ConsumptionState, consumption: Consumption) {
            state.editConsumption = consumption;
        }
    }
}
const consumptionModule = new ConsumptionModule();
export default consumptionModule;